import AxiosInstance from "../services/networkServices";

export const listPolls = async (payload) => {
  const res = await AxiosInstance.post(`/admin/polls/list`, payload);
  return res.data;
};

export const getPollHistory = async (programId, params = {}) => {
  const res = await AxiosInstance.get(
    `/admin/polls/program/${programId}/history`,
    { params }
  );
  return res.data;
};

export const createPoll = async (payload) => {
  const res = await AxiosInstance.post(`/admin/polls`, payload);
  return res.data;
};

export const updatePoll = async (id, payload) => {
  const res = await AxiosInstance.put(`/admin/polls/${id}`, payload);
  return res.data;
};

export const deletePoll = async (id) => {
  const res = await AxiosInstance.delete(`/admin/polls/${id}`);
  return res.data;
};
